import React from "react";

/**
 * MnuVerse logo — a stylised "M" arch (mountain peaks) merging into an orbiting
 * spark that suggests the menu universe (MnuVerse). Pure SVG, scales fluidly.
 *
 * Usage: <Logo size={32} /> or <Logo size={32} mark="dark" />
 */
export default function Logo({ size = 32, className = "", mark = "gold" }) {
  const stroke = mark === "dark" ? "#0A0A0C" : "#E5A93C";
  const accent = mark === "dark" ? "#E5A93C" : "#FFE3A3";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="MnuVerse logo"
      data-testid="brand-logo"
    >
      {/* Outer orbit */}
      <circle cx="24" cy="24" r="21" stroke={stroke} strokeOpacity="0.35" strokeWidth="1.4" strokeDasharray="2 3" />
      {/* M peaks */}
      <path
        d="M9 33 L9 16 L17 25 L24 16 L31 25 L39 16 L39 33"
        stroke={stroke}
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Spark — the 'verse' */}
      <circle cx="38.5" cy="13.5" r="2.6" fill={accent} />
      <circle cx="38.5" cy="13.5" r="2.6" stroke={stroke} strokeWidth="0.8" />
    </svg>
  );
}

export function LogoWordmark({ size = 32, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-wordmark">
      <Logo size={size} />
      <span className="font-display tracking-tight" style={{ fontSize: size * 0.78 }}>
        Mnu<span style={{ color: "#E5A93C" }}>Verse</span>
      </span>
    </span>
  );
}
